import React from "react";
import { Icon } from "../../../_components";

export function EventsManager() {
  return (
    <div className="chronos-help-topic-page chronos-events-manager-topic">
      <p>
        The <strong>Events Manager</strong> allows you to quickly view, search,
        manage, mass delete, and mass-move all Events in your Chronicle. Open
        the Events Manager by clicking the sparkle icon{" "}
        <Icon icon="far fa-sparkles fa-fw" />
        &nbsp;in the right toolbar.
      </p>
      <p>
        You can <strong>search</strong> all your Events here, using the search
        bar in the top left.
      </p>
      <p>
        Create a new event here using the{" "}
        <strong>
          <i className="fa fa-plus" />
          &nbsp;New Event
        </strong>{" "}
        button. You can also <strong>scroll</strong> through all the Events on
        your Chronicle, and quickly <strong>edit</strong> or{" "}
        <strong>delete</strong> them. When creating, editing, or deleting from
        here, completing these actions will take you back to the Events Manager
        for a faster workflow.
      </p>
      <p>
        When you select one or more Events by clicking the white check box, it
        gives you additional options - Mass <strong>Delete</strong> (again, all
        deletions are final) and <strong>Move To</strong>, which allows you to
        transfer multiple events between Timelines.
      </p>
    </div>
  );
}
